module.exports = __webpack_public_path__ + "static/media/bookmark_white.31cb88da.svg";